import { render } from "./BottomNav.vue?vue&type=template&id=c6946584&scoped=true"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"

import "./BottomNav.vue?vue&type=style&index=0&id=c6946584&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6946584"]])

export default __exports__